export function articleRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_ARTICLE_START":           
        case "FETCH_ARTICLES_START":                                 
        case "UPDATE_ARTICLE_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_ARTICLE_FULFILLED":           
        case "FETCH_ARTICLES_FULFILLED":                                 
        case "UPDATE_ARTICLE_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_ARTICLE_ERROR":
        case "FETCH_ARTICLES_ERROR":
        case "UPDATE_ARTICLE_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}